export const FIVE_YEARS_IN_MINUTES = 60 * 24 * 365 * 5;

export const TWELVE_HOURS_IN_MINUTES = 12 * 60;

export const ONE_HOUR_IN_MINUTES = 60;

export const SIX_MONTHS_IN_MINUTES = 6 * 30 * 24 * 60;

export const TWO_MINUTES_IN_MILISECONDS = 2 * 60 * 1000;
